import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { permissionSlugs } from './utils/permission.utils';
import { AuthzAccessHintService } from './shared/authz-access-hint/authz-access-hint.service';
import { AlertDialogService } from './shared/alert-dialog/alert-dialog.service';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
import * as i2 from "@angular/router";
import * as i3 from "./shared/authz-access-hint/authz-access-hint.service";
import * as i4 from "./shared/alert-dialog/alert-dialog.service";
var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(auth, router, authzAccessHint, alertDialog) {
        this.auth = auth;
        this.router = router;
        this.authzAccessHint = authzAccessHint;
        this.alertDialog = alertDialog;
    }
    AuthGuardService.prototype.canActivate = function (route) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var feature, permissionActions, requiredPermission, allowed, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.auth.isAuthenticated()];
                    case 1:
                        if (!(_a.sent())) {
                            this.router.navigate(['/login']);
                            return [2 /*return*/, false];
                        }
                        feature = route.data && route.data.feature;
                        if (route.data && route.data.allowWhenPanelOff && (!feature || !this.auth.getAuthzPanels().includes(feature))) {
                            return [2 /*return*/, true];
                        }
                        permissionActions = route.data && route.data.permissionActions;
                        requiredPermission = permissionActions
                            ? permissionSlugs(feature, permissionActions, this.auth.getAuthzPanels())
                            : route.data && route.data.permission;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 7]);
                        allowed = this.auth.isAuthorizedFor(requiredPermission, feature);
                        if (!!allowed) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.authzAccessHint.showAccessDeniedDialogForFeaturePanel(feature)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, this.resolveDeniedNavigation()];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        return [4 /*yield*/, this.alertDialog.open({
                                title: 'Authorization Error',
                                message: 'Failed to fetch user permissions from authorization service. Please try again or contact support.',
                                confirmText: 'OK',
                            })];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, this.resolveDeniedNavigation()];
                    case 7: return [2 /*return*/, true];
                }
            });
        });
    };
    // Direct URL / refresh: land on home so the sidenav shell is shown. In-app navigation: stay on the current screen.
    AuthGuardService.prototype.resolveDeniedNavigation = function () {
        if (this.shouldRedirectToHomeAfterDeny()) {
            return this.router.createUrlTree(['/']);
        }
        return false;
    };
    AuthGuardService.prototype.shouldRedirectToHomeAfterDeny = function () {
        var nav = this.router.getCurrentNavigation();
        return !nav || nav.previousNavigation == null;
    };
    AuthGuardService.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(i0.inject(i1.AuthService), i0.inject(i2.Router), i0.inject(i3.AuthzAccessHintService), i0.inject(i4.AlertDialogService)); }, token: AuthGuardService, providedIn: "root" });
    return AuthGuardService;
}());
export { AuthGuardService };
